import {SET_DIRECCION_ENVIO} from "../actions/constants";
import {createReducer} from "../../../_common/common.ts";

export const direccion_envio = createReducer(null, {

    [SET_DIRECCION_ENVIO]: (state, payload)=> payload,

});

